export default __webpack_public_path__ + "static/media/duplicatessn.c9a183fe.png";